<div class="panel-body">
	<div class="row input-group-btn">
	
		<div class="col-sm-6">
			<input [(ngModel)]="mResponseTimeValue" (ngModelChange)="onResponseTimeChange()" type="text" placeholder="60" style="color: #ffffff" class="form-control" />
		</div>
		
		<div class="col-sm-6">
		
			<span class="dropdown">
			
				<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					{{mUnit}}
					<span class="caret"></span>
				</button>
				
				<ul class="dropdown-menu" style="max-height: 250px; overflow-y: auto">
					<li (click)="mUnit = mUnits.SECONDS">
						<a class="ef">
							{{mUnits.SECONDS}}
						</a>
					</li>
					<li (click)="mUnit = mUnits.MINUTES">
						<a class="ef">
							{{mUnits.MINUTES}}
						</a>
					</li>
					<li (click)="mUnit = mUnits.HOURS">
						<a class="ef">
							{{mUnits.HOURS}}
						</a>
					</li>
					<li (click)="mUnit = mUnits.DAYS">
						<a class="ef">
							{{mUnits.DAYS}}
						</a>
					</li>
				</ul>
			</span>
		</div>
		
	</div>
</div>